/** SOLICITUD DEL RECIBO DEL ALTA DEL ESTABLECIMIENTO*/
import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../components/content/auth.jsx";
import { Api } from "./../app-controller.js";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import Swal from "sweetalert2";

class Inventory extends React.Component {
  initialState  = {
    disabled:true,
    procesando:false,
    options_est: [],
    options_prod: [],
    establecimiento_id:"",
    producto_id:"",
    num_lote:"",
    cantidad:"",
    vencimiento_lote: new Date().toISOString().slice(0, 10),
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;

    /**Declaro las funciones handle */
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleEstablecimiento = this.handleEstablecimiento.bind(this);
    this.handleChangeFecha = this.handleChangeFecha.bind(this);
  }

  componentDidMount() {
    Api.fetch(
      "app/getEstablishmentsForInventory"
    ).then((data) => {
      if (data) {
        this.setState({ options_est: data });
      }
    });
  }

  handleEstablecimiento(e) {
    this.setState({ establecimiento_id: e.target.value });
    Api.fetch(
      "app/getControlledProductsEst?establecimiento_id=" + e.target.value
    ).then((data) => {
      if (data) {
        if(data.length===0){
          Swal.fire({
            title: "Productos no encontrados",
            icon: "warning",
            text: "El establecimiento seleccionado no contiene productos controlados",
          });
        }else{
          this.setState({ options_prod: data });
        }
      }
    }); 
  }

  handleChangeFecha(e) {
    this.setState({ fecha: e.target.value });
  }

  handleSubmit(event) {
    //event.preventDefault();
    
    Api.loading(true);
    //crea la orden

    event.preventDefault();

    this.setState({ procesando: true });
  
    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };
    // shallow copy is inherit of the main state
    delete postData.options_est;
    delete postData.options_prod;


      Api.fetch("app/inventoryInscription", postData, "POST")
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            this.setState({ procesando: false });
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: "Revise la información e intente de nuevo su última acción", //message,
            });
          }); //catching errors to show notification
        }); 
  }


  handleRegister(e) {
    if (e.errors) {
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .replace("num", "No. de")
          .toUpperCase()}</li>`;
      }
      tplErrors += `</u>`; 
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      this.setState({ procesando: false });
      return false;
    } else {
      Swal.fire({
        title: "Inventario de producto añadido",
        icon: "success",
        text: "Su información ha sido recibida exitosamente.",
      }).then(() => {
        window.location = "/inventario/lista";
      });
    }
    this.setState({ procesando: false });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Home
          </li>
          <li className="breadcrumb-item active">Alta de inventario</li>
        </ol>
        <h1 className="page-header">
          Alta inventario
        </h1>

        <div className="row" >
          <div className="col-md-12">
            <Panel>
              <PanelBody>
              <fieldset className="col-sm-12">
                         
                      <div className="form-group ">
                      <label>Establecimiento: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="evento_tipo_id"
                        className="form-control m-b-5"
                        value={this.state.establecimiento_id}
                        onChange={this.handleEstablecimiento}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_est.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={ (this.state.options_prod.length>0 ) ? "row" : "hide"}>
                    <div className="form-group col-md-6">
                      <label>Producto: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="producto_id"
                        className="form-control m-b-5"
                        value={this.state.producto_id}
                        onChange={(e) =>
                          this.setState({
                            producto_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_prod.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.nombre_comercial}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Cantidad: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="number"
                        name="cantidad"
                        value={this.state.cantidad}
                        onChange={(e) =>
                          this.setState({
                            cantidad: e.target.value,
                          })
                        }
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                    </div>

                    <div className={ (this.state.options_prod.length>0 ) ? "row" : "hide"}>
                    <div className="form-group col-md-6">
                      <label>No. de lote: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="number"
                        name="num_lote"
                        value={this.state.num_lote}
                        onChange={(e) =>
                          this.setState({
                            num_lote: e.target.value,
                          })
                        }
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Fecha de vencimiento: </label>
                      <span className="text-danger"> *</span>

                      <input
                        type="date"
                        name="fecha"
                        onChange={this.handleChangeFecha}
                        id="fecha"
                        value={this.state.vencimiento_lote}
                        className="form-control"
                        placeholder="Seleccione"
                      />
                    </div>
                    </div>
                    <hr/>
                    <div className={ (this.state.options_prod.length>0 ) ? "form-group" : "hide"}>
                    <div
                    className={
                      this.state.procesando
                        ? "progress rounded-corner m-b-15"
                        : "hide"
                    }
                  >
                    <div
                      className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <h4>Cargando, espere...</h4>
                    </div>
                  </div>
                  <div
                    className={this.state.procesando ? "hide" : "pull-right"}
                  >
                    <button
                        type="submit"
                        onClick={this.handleSubmit}
                        className=" btn btn-primary m-r-5"
                      >
                        Generar
                      </button>
                      </div>
                      </div>
                </fieldset>
                </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Inventory auth={auth} history={history} {...props} />;
};
